import Vue from 'vue';
import Service from './service';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_COLABORATORS = 'UPDATE_COLABORATORS';
export const saveCollaboratorAction = 'saveCollaboratorAction';
export const initModuleAction = 'initModuleAction';
export default {
  namespaced: true,
  state: {
    error: '',
    loaded: false,
    types: {},
    colaborators: [],
  },
  mutations: {
    [CLEAR_MODULE](state) {
      Vue.set(state, 'types', {});
      Vue.set(state, 'loaded', false);
      Vue.set(state, 'error', '');
      Vue.set(state, 'colaborators', []);
    },
    [UPDATE_ERROR](state, payload) {
      Vue.set(state, 'error', payload);
    },
    [UPDATE_LOADED](state, payload) {
      Vue.set(state, 'loaded', payload);
    },
    [UPDATE_COLABORATORS](state, payload) {
      state.colaborators.push(payload);
    },
  },
  actions: {
    [initModuleAction]({ commit }) {
      commit(CLEAR_MODULE);
      return Service.getAllCollaborators()
        .then(list => list.forEach(collaborator => commit(UPDATE_COLABORATORS, collaborator)))
        .then(() => commit(UPDATE_LOADED, true));
    },
    [saveCollaboratorAction]({ commit, dispatch }, payload) {
      let promise = null;
      if ('id' in payload && payload.id !== 'dummy') {
        promise = Service.updateCollaborator(payload);
      } else if ('id' in payload && payload.id === 'dummy') {
        promise = Service.saveCollaborator(payload);
      } else {
        promise = Promise.reject('Incorrect data to save');
      }
      // return promise.then(res =>
      //   commit(UPDATE_COLABORATORS, res));
      return promise.then(() =>
        dispatch('initModuleAction'));
    },
  },
  getters: {
    loaded: state => state.loaded,
    colaborators: state => state.colaborators,
  },
};



// WEBPACK FOOTER //
// ./src/features/colaborador/store.js